import React, { Component, ErrorInfo, ReactNode } from "react";
import ReactGA from "react-ga4";
import { CategoryType } from "../constants/ga";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    ReactGA.event({
      category: CategoryType.UnClassifedError,
      action: CategoryType.UnClassifedError,
      label: JSON.stringify(errorInfo),
      nonInteraction: true,
    });
  }

  public render() {
    if (this.state.hasError) {
      return <h1>Sorry.. there was an error</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
